import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-rc.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-rc.component.scss?ngResource";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ViewApplicationLocationRcConstants } from "./view-location-location-rc.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { AppControllerService } from "../../../../../app-controller.service";
import { DatePipe } from "@angular/common";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ViewApplicationService } from "../../../view-application.service";
import { AlertType } from "../../../../../shared/models/alert";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { debounceTime } from "rxjs";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { RatesCertificateService } from "../../../../../shared/services/modules/rates-certificate.service";
import Query from "@arcgis/core/rest/support/Query";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let ViewApplicationLocationRcComponent = class ViewApplicationLocationRcComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    appController;
    datePipe;
    modalService;
    routerParamsService;
    recipientSelectService;
    changeDetectorRefs;
    ratesCertificateService;
    mapService;
    requestStatusService;
    viewApplicationService;
    activeTabIndex;
    propertiesForm;
    descriptionLabel1 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_4;
    validationMessages = ViewApplicationLocationRcConstants.VALIDATION_MESSAGES;
    erfNoControl = ViewApplicationLocationRcConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationRcConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationRcConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationRcConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationRcConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationRcConstants.ADDRESS_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationRcConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationRcConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationRcConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationRcConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationRcConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationRcConstants.ADDRESS_TEXT_PLACEHOLDER;
    removePropertyLabel = ViewApplicationLocationRcConstants.REMOVE_PROPERTY_LABEL;
    managingAgentDisableFilterBy = true;
    managingAgentDisableAdd = false;
    managingAgentDisableEditing = false;
    managingAgentGroups = [];
    managingAgentLabel = "Managing agent";
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    mapComponent;
    isMapLoaded = false;
    zones = [];
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    titleDeedNumberControl = ViewApplicationLocationRcConstants.TITLE_DEED_NUMBER_CONTROL;
    zoningControl = ViewApplicationLocationRcConstants.ZONING_CONTROL;
    sectionalTitleSchemeNameControl = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NAME_CONTROL;
    sectionalTitleSchemeNumberControl = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NUMBER_CONTROL;
    sectionalTitleSchemeUnitControl = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_UNIT_CONTROL;
    extentControl = ViewApplicationLocationRcConstants.EXTENT_CONTROL;
    purchasePriceControl = ViewApplicationLocationRcConstants.PURCHASE_PRICE_CONTROL;
    dateOfSaleControl = ViewApplicationLocationRcConstants.DATE_OF_SALE_CONTROL;
    electricityAccountNumberControl = ViewApplicationLocationRcConstants.ELECTRICITY_ACCOUNT_NUMBER_CONTROL;
    waterAccountNumberControl = ViewApplicationLocationRcConstants.WATER_ACCOUNT_NUMBER_CONTROL;
    refuseAccountNumberControl = ViewApplicationLocationRcConstants.REFUSE_ACCOUNT_NUMBER_CONTROL;
    managingAgentControl = ViewApplicationLocationRcConstants.MANAGING_AGENT_CONTROL;
    titleDeedNumberLabel = ViewApplicationLocationRcConstants.TITLE_DEED_NUMBER_LABEL;
    zoningLabel = ViewApplicationLocationRcConstants.ZONING_LABEL;
    sectionalTitleSchemeNameLabel = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NAME_LABEL;
    sectionalTitleSchemeNumberLabel = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NUMBER_LABEL;
    sectionalTitleSchemeUnitLabel = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_UNIT_LABEL;
    extentLabel = ViewApplicationLocationRcConstants.EXTENT_LABEL;
    purchasePriceLabel = ViewApplicationLocationRcConstants.PURCHASE_PRICE_LABEL;
    dateOfSaleLabel = ViewApplicationLocationRcConstants.DATE_OF_SALE_LABEL;
    electricityAccountNumberLabel = ViewApplicationLocationRcConstants.ELECTRICITY_ACCOUNT_NUMBER_LABEL;
    waterAccountNumberLabel = ViewApplicationLocationRcConstants.WATER_ACCOUNT_NUMBER_LABEL;
    refuseAccountNumberLabel = ViewApplicationLocationRcConstants.REFUSE_ACCOUNT_NUMBER_LABEL;
    modalOptions = ViewApplicationLocationRcConstants.MODAL_OPTION;
    application;
    getApplicationSetPropertiesObservableSubscription;
    getStepMetaObservableSubscription;
    selectedPropertySubscription;
    constructor(aflaModuleStrategyService, route, appController, datePipe, modalService, routerParamsService, recipientSelectService, changeDetectorRefs, ratesCertificateService, mapService, requestStatusService, viewApplicationService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.appController = appController;
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.routerParamsService = routerParamsService;
        this.recipientSelectService = recipientSelectService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.ratesCertificateService = ratesCertificateService;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.viewApplicationService = viewApplicationService;
    }
    ngOnInit() {
        if (this.aflaModuleStrategyService.lookups.has("zoning")) {
            this.zones = this.aflaModuleStrategyService.lookups.get("zoning");
        }
        else {
            this.getLookups();
        }
        this.initForm();
        this.listenForRouteParamChange();
        this.subscribeToProperty();
        this.changeDetectorRefs.detectChanges();
    }
    handleRouteChange() {
        this.initialiseForm();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        try {
            this.managingAgentGroups = stepMeta.managingAgentGroup;
            if (this.managingAgentGroups[0].hasOwnProperty("requiredFields") && this.managingAgentGroups[0].requiredFields !== null) {
                this.managingAgentGroups = this.recipientSelectService.checkStepMetaRecipientGroups(this.managingAgentGroups);
            }
            this.getApplicantData();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
        dialogRef.componentInstance.title = "Delete property";
        dialogRef.componentInstance.contentMessage = "Are you sure you want to remove the selected property?";
        dialogRef.componentInstance.data = true;
        dialogRef.result.then((deleteProperty) => {
            this.changeDetectorRefs.markForCheck();
            if (deleteProperty) {
                this.getProperties().removeAt(propertyIndex);
                this.mapComponent.clearGraphics("Rates certificate graphics");
                this.changeDetectorRefs.detectChanges();
            }
        });
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyData");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(ViewApplicationLocationRcConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyData");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                titleDeedNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TitleDeed", "titledeed"), [Validators.required]),
                zoning: new FormControl(null, [Validators.required]),
                sectionalTitleSchemeName: new FormControl(null),
                sectionalTitleSchemeNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "SgDiagramNo", "sgdiagramno")),
                sectionalTitleSchemeUnit: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "UnitNumber", "unitnumber")),
                extent: new FormControl(null, [Validators.required]),
                purchasePrice: new FormControl(null, [Validators.required]),
                dateOfSale: new FormControl(null, [Validators.required]),
                electricityAccountNumber: new FormControl(null),
                waterAccountNumber: new FormControl(null),
                refuseAccountNumber: new FormControl(null),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                managingAgent: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.viewApplicationService.getTrueCentroid(url, formData)
                .subscribe({
                next: (trueCentroidResponse) => {
                    this.setPropertyTrueCentroidData(newProperty, trueCentroidResponse);
                    this.setPropertyZoning(newProperty, sgCode);
                    this.changeDetectorRefs.detectChanges();
                    this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("GetPropertyData");
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyData");
                    this.appController.handleServerErrorMessage(ViewApplicationLocationRcConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    setPropertyTrueCentroidData(newFormGroup, trueCentroidResponse) {
        const propertiesArray = this.getProperties();
        newFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
        propertiesArray.push(newFormGroup);
        this.activeTabIndex = propertiesArray.length - 1;
        this.updateRequiredFields(this.activeTabIndex);
        this.changeDetectorRefs.detectChanges();
    }
    setPropertyZoning(newFormGroup, sgCode) {
        const zoningControl = newFormGroup.get(this.zoningControl);
        const zoningLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property zone");
        if (zoningLayerObj !== undefined && zoningLayerObj !== null) {
            const zoningLayer = zoningLayerObj.layer;
            const zoningQuery = new Query();
            zoningQuery.where = `SgCode = '${sgCode}' or sgcode = '${sgCode}'`;
            zoningQuery.returnGeometry = false;
            zoningQuery.outFields = ["*"];
            zoningLayer.queryFeatures(zoningQuery).then((zoneFeatureSet) => {
                if (zoneFeatureSet.features.length > 0) {
                    zoneFeatureSet.features.forEach(item => {
                        const zone = this.propertyDataAlternateColumnName(item.attributes, "Zoning", "zoning"); // zone from the property layer
                        if (zone !== undefined && zone != null) {
                            let foundZone = null;
                            this.zones.forEach(zoneItem => {
                                if (zoneItem.value === zone) {
                                    foundZone = zoneItem;
                                }
                            });
                            if (zoningControl) {
                                zoningControl.setValue(zone);
                            }
                        }
                        else {
                            this.appController.showMessage(ViewApplicationLocationRcConstants.ZONING_NOT_FOUND.replace("{0}", zone), AlertType.Error);
                            const params = {
                                moduleId: this.moduleID, lookupType: "Zoning", lookupList: [zone]
                            };
                            this.viewApplicationService.sendMissingLookupsEmail(params).subscribe();
                        }
                    });
                }
                else {
                    this.appController.showMessage(ViewApplicationLocationRcConstants.INVALID_ZONING_ATTRIBUTE, AlertType.Error);
                }
            });
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Rates certificate graphics", true);
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    getApplicantData() {
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `properties($expand=managingAgent($expand=groups))`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).subscribe((returnValue) => {
            const propertyControl = this.getProperties();
            propertyControl.clear();
            this.application = returnValue.value[0];
            this.application.properties.forEach(property => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const dateString = this.datePipe.transform(property.dateOfSale, ViewApplicationLocationRcConstants.DATE_CONST);
                const newProperty = new FormGroup({
                    property: new FormControl(property),
                    erfNo: new FormControl(property.erfNumber, [Validators.required]),
                    subdivision: new FormControl(property.subdivision, [Validators.required]),
                    allotment: new FormControl(property.allotment, [Validators.required]),
                    farmNo: new FormControl(property.farmNumber, [Validators.required]),
                    sgCode: new FormControl(property.sgCode, [Validators.required]),
                    address: new FormControl(property.address, [Validators.required]),
                    geometry: new FormControl(geom),
                    centroid: new FormControl(null, [Validators.required]),
                    titleDeedNumber: new FormControl(property.titleDeedNumber, [Validators.required]),
                    zoning: new FormControl(property.zoning, [Validators.required]),
                    sectionalTitleSchemeName: new FormControl(property.sectionalTitleSchemeName),
                    sectionalTitleSchemeNumber: new FormControl(property.sectionalTitleSchemeNumber),
                    sectionalTitleSchemeUnit: new FormControl(property.sectionalTitleSchemeUnit),
                    extent: new FormControl(property.extent?.toFixed(2), [Validators.required]),
                    purchasePrice: new FormControl(property.purchasePrice?.toFixed(2), [Validators.required]),
                    dateOfSale: new FormControl(dateString, [Validators.required]),
                    electricityAccountNumber: new FormControl(property.electricityAccountNumber),
                    waterAccountNumber: new FormControl(property.waterAccountNumber),
                    refuseAccountNumber: new FormControl(property.refuseAccountNumber),
                    managingAgent: new FormControl(null, [Validators.required])
                });
                const mangingAgentControl = newProperty.get(this.managingAgentControl);
                this.recipientSelectService.setRecipient(property.managingAgent[0], false, mangingAgentControl);
                const proxyUrl = ApiProxyConstants.URL;
                const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                const url = `${proxyUrl}?${gpToolUrl}`;
                const formData = new FormData();
                formData.append("f", "json");
                formData.append("geometryJSON", JSON.stringify(geometryArc));
                this.viewApplicationService.getTrueCentroid(url, formData)
                    .subscribe({
                    next: (response) => {
                        newProperty.get("centroid").setValue(response.results[0].value);
                        propertyControl.push(newProperty);
                        this.activeTabIndex = propertyControl.length - 1;
                        this.changeDetectorRefs.detectChanges();
                        this.updateRequiredFields(propertyControl.length - 1);
                        if (this.isMapLoaded) {
                            this.syncMapGeometries();
                        }
                        this.changeDetectorRefs.detectChanges();
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationRcConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.changeDetectorRefs.detectChanges();
        });
    }
    onBtnSaveClicked() {
        if (this.propertiesForm.valid) {
            const points = [];
            const properties = [];
            const propertiesArray = this.getProperties();
            const item = propertiesArray.controls[0];
            const centroid = item.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
            const geometry = item.get("geometry").value;
            const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            const managingAgent = item.get(this.managingAgentControl).value;
            RecipientUtils.removeRecipientProperties(managingAgent);
            const extentStringValue = item.get(this.extentControl).value;
            const purchasePriceStringValue = item.get(this.purchasePriceControl).value;
            const extentDecimalValue = parseFloat(extentStringValue?.trim());
            const purchasePriceDecimalValue = parseFloat(purchasePriceStringValue?.trim());
            const property = {
                address: item.get("address").value,
                allotment: item.get("allotment").value,
                erfNumber: item.get("erfNo").value,
                farmNumber: item.get("farmNo").value,
                isDummy: false,
                sgCode: item.get("sgCode").value,
                shape: geometryJSON,
                subdivision: item.get("subdivision").value,
                titleDeedNumber: item.get("titleDeedNumber").value,
                zoning: item.get("zoning").value,
                sectionalTitleSchemeName: item.get("sectionalTitleSchemeName").value,
                sectionalTitleSchemeNumber: item.get("sectionalTitleSchemeNumber").value,
                sectionalTitleSchemeUnit: item.get("sectionalTitleSchemeUnit").value,
                extent: extentDecimalValue,
                purchasePrice: purchasePriceDecimalValue,
                dateOfSale: item.get("dateOfSale").value,
                electricityAccountNumber: item.get("electricityAccountNumber").value,
                waterAccountNumber: item.get("waterAccountNumber").value,
                refuseAccountNumber: item.get("refuseAccountNumber").value,
                updateGeometry: false,
                wkid: 102100,
                managingAgent: [managingAgent]
            };
            properties.push(property);
            const params = {
                property: properties[0],
                applicationShape: `MULTIPOINT (${points.join(", ")})`,
                applicationWkid: 102100
            };
            this.getApplicationSetPropertiesObservableSubscription =
                this.ratesCertificateService.getApplicationSetPropertiesObservable(this.application.id, params)
                    .subscribe({
                    next: () => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationRcConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appController.selectedModuleID}`,
        };
        this.viewApplicationService.getLookupsObservable(params).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationRcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.toLowerCase() === "zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("zoning", zones);
        this.zones = zones;
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: AppControllerService },
        { type: DatePipe },
        { type: NgbModal },
        { type: RouterParamsService },
        { type: RecipientSelectService },
        { type: ChangeDetectorRef },
        { type: RatesCertificateService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ViewApplicationService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationRcComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-location-rc",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationLocationRcComponent);
export { ViewApplicationLocationRcComponent };
